import { render } from "./quarter.vue?vue&type=template&id=3066e310&scoped=true"
import script from "./quarter.vue?vue&type=script&lang=js"
export * from "./quarter.vue?vue&type=script&lang=js"

import "./quarter.vue?vue&type=style&index=0&id=3066e310&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3066e310"]])

export default __exports__